import {
  FAQItem,
  GlossaryItem,
  GuidedGameStep,
  MistakeItem,
  PlayerCount,
  QuickReferenceSection,
  RuleSection,
} from '../types';
import { isVisibleForPlayerCount } from '../configuration';

export function filterSectionsForPlayerCount(
  sections: RuleSection[],
  playerCount: PlayerCount
): RuleSection[] {
  return sections.filter((section) =>
    isVisibleForPlayerCount(section.players, playerCount)
  );
}

export function filterFaqForPlayerCount(
  items: FAQItem[],
  playerCount: PlayerCount
): FAQItem[] {
  return items.filter((item) =>
    isVisibleForPlayerCount(item.players, playerCount)
  );
}

export function filterMistakesForPlayerCount(
  items: MistakeItem[],
  playerCount: PlayerCount
): MistakeItem[] {
  return items.filter((item) =>
    isVisibleForPlayerCount(item.players, playerCount)
  );
}

export function filterGlossaryForPlayerCount(
  items: GlossaryItem[],
  playerCount: PlayerCount
): GlossaryItem[] {
  return items.filter((item) =>
    isVisibleForPlayerCount(item.players, playerCount)
  );
}

export function filterQuickReferenceForPlayerCount(
  items: QuickReferenceSection[],
  playerCount: PlayerCount
): QuickReferenceSection[] {
  return items.filter((item) =>
    isVisibleForPlayerCount(item.players, playerCount)
  );
}

export function filterGuidedStepsForPlayerCount(
  steps: GuidedGameStep[],
  playerCount: PlayerCount
): GuidedGameStep[] {
  return steps.filter((step) =>
    isVisibleForPlayerCount(step.players, playerCount)
  );
}

export function filterFaqItems(query: string, items: FAQItem[]): FAQItem[] {
  const q = query.trim().toLocaleLowerCase('pl');
  if (!q) return items;
  return items.filter((item) =>
    `${item.question} ${item.answer} ${item.tags?.join(' ') ?? ''}`
      .toLocaleLowerCase('pl')
      .includes(q)
  );
}

export function groupFaqItems(
  items: FAQItem[]
): { group: string; items: FAQItem[] }[] {
  const map = new Map<string, FAQItem[]>();
  for (const item of items) {
    const group = item.group ?? 'Ogólne';
    const list = map.get(group) ?? [];
    list.push(item);
    map.set(group, list);
  }
  return Array.from(map.entries()).map(([group, groupItems]) => ({
    group,
    items: groupItems,
  }));
}
